import { useNotifications as useToolpadNotifications } from "@toolpad/core/useNotifications";
import { useMemo } from "react";
export function useNotifications() {
    const { close, show } = useToolpadNotifications();
    return useMemo(()=>({
            close: (key)=>close(key),
            error: (message, options)=>show(message, {
                    ...options,
                    severity: 'error'
                }),
            info: (message, options)=>show(message, {
                    ...options,
                    severity: 'info'
                }),
            success: (message, options)=>show(message, {
                    ...options,
                    severity: 'success'
                }),
            warning: (message, options)=>show(message, {
                    ...options,
                    severity: 'warning'
                })
        }), [
        close,
        show
    ]);
}

//# sourceMappingURL=useNotifications.js.map